module.exports = __webpack_public_path__ + "img/calendar-rotate.576a4a14.svg";